import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d675343")

_pushScopeId("data-v-5d675343")
const _hoisted_1 = {
  "data-testid": "booking-v4-sticky-footer-container",
  class: "booking-v4-sticky-footer"
}
const _hoisted_2 = {
  key: 0,
  class: "reverse-journey-total-tariff"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ChargeableWeightSummaryV4 = _resolveComponent("ChargeableWeightSummaryV4")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isReverseJourney)
      ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("bookingV4.footer.totalTariff")), 1))
      : (_openBlock(), _createBlock(_component_ChargeableWeightSummaryV4, {
          key: 1,
          class: "booking-v4-sticky-footer__chargeable-weight",
          chargeableWeightKg: _ctx.chargeableWeightKg,
          totalKoli: _ctx.totalKoli,
          chargeableWeightExpanded: _ctx.chargeableWeightExpandedModelValue,
          "onUpdate:chargeableWeightExpanded": _cache[1] || (_cache[1] = ($event: any) => (_ctx.chargeableWeightExpandedModelValue = $event)),
          chargeableWeightBreakdown: _ctx.chargeableWeightBreakdown,
          woodpacking: _ctx.woodpacking,
          "onUpdate:protectionPacking": _ctx.onUpdateProtectionPacking,
          numericLocale: _ctx.numericLocale
        }, null, 8, ["chargeableWeightKg", "totalKoli", "chargeableWeightExpanded", "chargeableWeightBreakdown", "woodpacking", "onUpdate:protectionPacking", "numericLocale"])),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
})